import React from "react";
import type { ButtonProps} from "@chakra-ui/react";
import { Button, Icon } from "@chakra-ui/react";
import { ReactComponent as VivoPayLogo } from "../../assets/icons/vivo-pay-logo.svg";
import { colors } from "../../theme/colors";

interface IVivoLogo extends ButtonProps {
	clickable?: boolean;
	variant?: "purple" | "white";
}

export const VivoLogo = ({ clickable, variant = "purple", ...rest }: IVivoLogo) => {
	const variantColors = {
		purple: colors.purple[500],
		white: colors.white[500],
	};

	return (
		<Button
			variant="unstyled"
			paddingInline={0}
			marginInline={0}
			h="40px"
			type="button"
			_focus={{ outline: "none" }}
			pointerEvents={clickable ? "auto" : "none"}
			{...rest}
		>
			<Icon as={VivoPayLogo} w="100%" h="100%" aria-label="Vivo Logo" color={variantColors[variant]} />
		</Button>
	);
};
